import React, { useCallback, useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Machines from "@/components/landing/WhatWeDo";
import HowItWorks from "@/components/landing/HowItWorks";
import WhyUs from "@/components/landing/WhyUs";
import Industries from "@/components/landing/Industries";
import SocialProof from "@/components/landing/SocialProof";
import Footer from "@/components/landing/Footer";
import InquiryModal from "@/components/landing/InquiryModal";
import FloatingInquiryButton, {
  useAutoTriggerInquiry,
} from "@/components/landing/FloatingInquiryButton";

import ProductPage from "@/pages/ProductPage";
import ProductIndexPage from "@/pages/ProductIndexPage";
import CityPage from "@/pages/CityPage";
import CityIndexPage from "@/pages/CityIndexPage";
import FaqPage from "@/pages/FaqPage";

function LandingPage() {
  const [modalOpen, setModalOpen] = useState(false);
  const [autoTriggered, setAutoTriggered] = useState(false);

  const open = useCallback(() => setModalOpen(true), []);

  useAutoTriggerInquiry({
    enabled: !autoTriggered && !modalOpen,
    onTrigger: () => {
      setAutoTriggered(true);
      setModalOpen(true);
    },
  });

  return (
    <div className="min-h-screen bg-white text-zinc-950 antialiased selection:bg-emerald-500 selection:text-white">
      <Header onOpenInquiry={open} />
      <main>
        <Hero onOpenInquiry={open} />
        <Machines />
        <HowItWorks />
        <WhyUs />
        <Industries />
        <SocialProof />
      </main>
      <Footer onOpenInquiry={open} />
      <FloatingInquiryButton onClick={open} />
      <InquiryModal open={modalOpen} onOpenChange={setModalOpen} />
    </div>
  );
}

/** Scroll to top (or to the URL's hash) on route change. */
function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/products" element={<ProductIndexPage />} />
        <Route path="/products/:slug" element={<ProductPage />} />
        <Route path="/vending-machines" element={<CityIndexPage />} />
        <Route path="/vending-machines/:city" element={<CityPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster
        theme="light"
        position="top-right"
        toastOptions={{
          style: {
            background: "#ffffff",
            color: "#0a0a0a",
            border: "1px solid #e4e4e7",
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
